/**
 * BarcodeSearch component allows users to search for returns receipts by entering a barcode.
 *
 * @component
 * @example
 * return (
 *   <BarcodeSearch />
 * )
 *
 * @returns {JSX.Element} The BarcodeSearch component.
 *
 * @description
 * This component renders a form with an input field for entering a barcode and a search button.
 * When the form is submitted, it dispatches an action to get the returns receipt associated with the entered barcode
 * and navigates to the returns page. If the user is not logged in, they are redirected to the login page.
 *
 * @requires useNavigate from 'react-router-dom'
 * @requires useDispatch from 'react-redux'
 * @requires Container, Form, Button from 'react-bootstrap'
 * @requires getreturnsReceipt from '../actions/posActions'
 */
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Container, Form, Button } from 'react-bootstrap'
import { getreturnsReceipt } from '../actions/posActions'

let cid

const BarcodeSearch = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [barcode, setBarcode] = useState('')

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  const ownerLogin = useSelector((state) => state.ownerLogin)
  const { ownerInfo } = ownerLogin

  const activeSession = ownerInfo || userInfo

  if (activeSession) {
    cid = activeSession.cid
  }

  // Redirect to login if not logged in
  useEffect(() => {
    if (!activeSession) {
      navigate('/login')
    }
  }, [activeSession, navigate])

  // Reset returns state if no barcode
  useEffect(() => {
    if (barcode === '' || barcode === undefined) {
      dispatch({ type: 'RETURNS_RESET' })
    }
  }, [dispatch, barcode])

  // Handle search
  const handleSearch = (e) => {
    e.preventDefault()
    dispatch(getreturnsReceipt(barcode, cid))
    navigate(`/returns`)
  }

  // Render
  return (
    <Container className='search-shell'>
      <Form
        onSubmit={handleSearch}
        className='d-flex align-items-center gap-2 flex-wrap'
      >
        <Form.Control
          autoFocus
          type='text'
          name='barcode'
          placeholder='Enter barcode'
          value={barcode}
          onChange={(e) => setBarcode(e.target.value)}
          className='search-input my-2'
        />
        <Button
          type='submit'
          variant='outline-secondary'
          size='sm'
          className='search-action-btn my-1'
        >
          Search
        </Button>
      </Form>
    </Container>
  )
}

export default BarcodeSearch
